/**
 * Проверяет, является ли текущий домен разрешенным для отображения dev-функций
 * @returns {boolean} true, если домен разрешен
 */
export const isDevelopmentDomain = () => {
  const currentDomain = window.location.hostname;
  const allowedDomains = ['localhost', 'kampus.local', '127.0.0.1'];

  return allowedDomains.includes(currentDomain);
};

export const isDevModeForTesting = () => {
  return Boolean(window.localStorage.getItem('devMode'));
};
/**
 * Проверяет, является ли текущая среда разработкой
 * @returns {boolean} true, если это dev среда
 */
export const isDevelopmentMode = () => {
  return process.env.NODE_ENV === 'development' || isDevelopmentDomain() || isDevModeForTesting();
};

/**
 * Получает список разрешенных доменов
 * @returns {string[]} массив разрешенных доменов
 */
export const getAllowedDomains = () => {
  return ['localhost', 'kampus.local', '127.0.0.1'];
};
